export default "__VITE_ASSET__B1iubv2N__"